import { definePart } from '../core/effect';
import { glowStroke, rgba } from '../canvas/paint';

/**
 * **輪**（Issue #528）。魔法陣・照準・衝撃波の基礎。
 *
 * 目盛り（`ticks`）を 0 にすればただの輪。**回すのは器の仕事**（`tf/…/rotation`）なので、
 * ここは「止まっている 1 枚の絵」だけを描く。
 */
export default definePart({
  id: 'ring',
  /** 素の大きさ（`{ screen: [x, y] }` は点なのでアンカーから取れない。Issue #537） */
  size: { w: 520, h: 520 },
  label: '輪',
  schema: {
    color: { type: 'color', label: '色' },
    width: { type: 'number', label: '線の太さ', min: 1, max: 40, step: 1 },
    radius: { type: 'number', label: '半径（大きさに対する割合）', min: 0.1, max: 0.5, step: 0.01 },
    ticks: { type: 'number', label: '目盛りの数', min: 0, max: 36, step: 1 },
    tickLen: { type: 'number', label: '目盛りの長さ', min: 0, max: 0.5, step: 0.01 },
    glow: { type: 'number', label: 'にじみ', min: 0, max: 30, step: 1 },
  },
  style: { color: '#7ad7ff', width: 6, radius: 0.42, ticks: 0, tickLen: 0.12, glow: 8 },

  draw(ctx, { size, style }) {
    const cx = size.w / 2;
    const cy = size.h / 2;
    const r = Math.min(size.w, size.h) * style.radius;
    if (r <= 0) return;
    const circle = () => { ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); };
    // にじみは**太い線の重ね塗り**（`canvas/paint::glowStroke`。紙では影は重く、環境で出方も違う）
    glowStroke(ctx, circle, {
      color: style.color, strokeW: style.width, glowW: style.glow, glowA: 0.22, glowN: 3,
    });
    if (style.ticks > 0 && style.tickLen > 0) {
      const inner = r * (1 - style.tickLen);
      const outer = r * (1 + style.tickLen);
      ctx.strokeStyle = rgba(style.color, 0.9);
      ctx.lineWidth = Math.max(1, style.width * 0.6);
      ctx.beginPath();
      for (let i = 0; i < style.ticks; i += 1) {
        const a = (i / style.ticks) * Math.PI * 2;
        ctx.moveTo(cx + Math.cos(a) * inner, cy + Math.sin(a) * inner);
        ctx.lineTo(cx + Math.cos(a) * outer, cy + Math.sin(a) * outer);
      }
      ctx.stroke();
    }
  },
});
